import * as React from 'react';

import {FormField} from 'shells/form/form-field';
import {TextField} from 'shells/textfield/textfield';

import styles from './port.module.css';

type Props = {
    value: string;
    onChange: (arg1: string) => void;
    onEnter?: () => void;
};

export function Port(props: Props) {
    return (
        <FormField
            innerId='port'
            label='Port'
            errorMessage={null} // TODO
        >
            <div className={styles.port}>
                <TextField
                    // @ts-expect-error
                    name='port'
                    placeholder='465'
                    title='Port'
                    type='number'
                    value={props.value}
                    onChange={props.onChange}
                    onEnter={props.onEnter}
                />
            </div>
        </FormField>
    );
}
